// src/providers/MDFeProviders.js
import React from 'react';
import { MDFeProvider } from '../contexts/fiscal/MDFeContext';
import { TransporteFiscalProvider } from '../contexts/fiscal/TransporteFiscalContext';

const MDFeProviders = ({ children }) => (
  <TransporteFiscalProvider>
    <MDFeProvider>{children}</MDFeProvider>
  </TransporteFiscalProvider>
);

export default MDFeProviders;
